import React from 'react'

function Blog() {
  return (
    <>
    <div>
  {/* header-area */}
  <header id="header">
    <div id="sticky-header" className="menu-area menu-style-two transparent-header">
      <div className="container custom-container-three">
        <div className="row">
          <div className="col-12">
            <div className="mobile-nav-toggler"><i className="fas fa-bars" /></div>
            <div className="menu-wrap">
              <nav className="menu-nav">
                <div className="logo">
                  <a href="/"><img src="assets/img/logo/logo.png" alt /></a>
                </div>
                <div className="navbar-wrap main-menu d-none d-lg-flex">
                  <ul className="navigation">
                    <li className="menu-item-has-children"><a href="#header">Home</a>
                      <ul className="sub-menu">
                        <li><a href="/">Home One</a></li>
                        <li><a href="index">Home Two</a></li>
                      </ul>
                    </li>
                    <li><a href="/#about">About us</a></li>
                    <li><a href="/#sales">Sales</a></li>
                    <li><a href="/#roadmap">Roadmap</a></li>
                    <li className="active menu-item-has-children"><a href="/blog">Blog</a>
                      <ul className="sub-menu">
                        <li className="active"><a href="/blog">Our Blog</a></li>
                        <li><a href="/blog-details">Blog Details</a></li>
                      </ul>
                    </li>
                    <li><a href="/#contact">Contact us</a></li>
                  </ul>
                </div>
                <div className="header-action d-none d-md-block">
                  <ul>
                    <li className="header-lang"><span className="selected-lang">ENG</span>
                      <ul className="lang-list">
                        <li><a href="#">IND</a></li>
                        <li><a href="#">BNG</a></li>
                        <li><a href="#">TUR</a></li>
                        <li><a href="#">CIN</a></li>
                      </ul>
                    </li>
                    <li className="header-btn"><a href="#" className="btn">Buy Now</a></li>
                  </ul>
                </div>
              </nav>
            </div>
            {/* Mobile Menu  */}
            <div className="mobile-menu">
              <nav className="menu-box">
                <div className="close-btn"><i className="fas fa-times" /></div>
                <div className="nav-logo"><a href="/"><img src="assets/img/logo/logo.png" alt title /></a>
                </div>
                <div className="menu-outer">
                  {/*Here Menu Will Come Automatically Via Javascript / Same Menu as in Header*/}
                </div>
                <div className="social-links">
                  <ul className="clearfix">
                    <li><a href="#"><i className="fab fa-facebook-f" /></a></li>
                    <li><a href="#"><i className="fab fa-twitter" /></a></li>
                    <li><a href="#"><i className="fab fa-instagram" /></a></li>
                    <li><a href="#"><i className="fab fa-linkedin-in" /></a></li>
                    <li><a href="#"><i className="fab fa-youtube" /></a></li>
                  </ul>
                </div>
              </nav>
            </div>
            <div className="menu-backdrop" />
            {/* End Mobile Menu */}
          </div>
        </div>
      </div>
    </div>
  </header>
  {/* header-area-end */}
  {/* main-area */}
  <main>
    {/* breadcrumb-area */}
    <section className="breadcrumb-area breadcrumb-bg">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="breadcrumb-content">
              <h2 className="title">Blog &amp; Article</h2>
              <nav aria-label="Breadcrumbs">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/"><span>Home</span></a>
                  </li>
                  <li className="breadcrumb-item"><span>Blog</span></li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </section>
    {/* breadcrumb-area-end */}
    {/* blog-area */}
    <section className="blog-area pt-130 pb-130">
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <div className="blog-post-item">
              <div className="blog-post-thumb">
                <a href="/blog-details"><img src="assets/img/blog/blog_img01.jpg" alt /></a>
              </div>
              <div className="blog-post-content">
                <div className="blog-meta">
                  <ul>
                    <li><a href="/blog-details"><i className="far fa-user" />Alextina</a></li>
                    <li><i className="far fa-clock" />Dec 28, 2023</li>
                    <li><a href="/blog-details"><i className="fas fa-comment-dots" />(04) Coments</a></li>
                  </ul>
                </div>
                <h2 className="title"><a href="/blog-details">New trends in UI/UX Design World of crypto Integration of this year</a></h2>
                <p>Laboratories used for scientific research take many forms because of the differing requirements of specialists in the various fields of science and engineering. A physics laboratory</p>
                <a href="/blog-details" className="btn btn-two">Read more <i className="fas fa-arrow-right" /></a>
              </div>
            </div>
            <div className="blog-post-item">
              <div className="blog-post-thumb">
                <a href="/blog-details"><img src="assets/img/blog/blog_img02.jpg" alt /></a>
              </div>
              <div className="blog-post-content">
                <div className="blog-meta">
                  <ul>
                    <li><a href="/blog-details"><i className="far fa-user" />Alextina</a></li>
                    <li><i className="far fa-clock" />Dec 28, 2023</li>
                    <li><a href="/blog-details"><i className="fas fa-comment-dots" />(04) Coments</a></li>
                  </ul>
                </div>
                <h2 className="title"><a href="/blog-details">That Time We Burned Down Players’ <br /> Houses in Ultima Online</a></h2>
                <p>Laboratories used for scientific research take many forms because of the differing requirements of specialists in the various fields of science and engineering. A physics laboratory</p>
                <a href="/blog-details" className="btn btn-two">Read more <i className="fas fa-arrow-right" /></a>
              </div>
            </div>
            <div className="blog-post-item">
              <div className="blog-post-thumb">
                <a href="/blog-details"><img src="assets/img/blog/blog_img03.jpg" alt /></a>
              </div>
              <div className="blog-post-content">
                <div className="blog-meta">
                  <ul>
                    <li><a href="/blog-details"><i className="far fa-user" />Alextina</a></li>
                    <li><i className="far fa-clock" />Dec 28, 2023</li>
                    <li><a href="/blog-details"><i className="fas fa-comment-dots" />(04) Coments</a></li>
                  </ul>
                </div>
                <h2 className="title"><a href="/blog-details">Why Your Next ‘Yes’ Hire Might Come From Someone Who Just Said</a></h2>
                <p>Laboratories used for scientific research take many forms because of the differing requirements of specialists in the various fields of science and engineering. A physics laboratory</p>
                <a href="/blog-details" className="btn btn-two">Read more <i className="fas fa-arrow-right" /></a>
              </div>
            </div>
            <div className="pagination-wrap">
              <ul className="list-wrap">
                <li className="prv-next">
                  <a href="/blog"><i className="fas fa-angle-double-left" /></a>
                </li>
                <li><a href="/blog">1</a></li>
                <li><a href="/blog" className="current">2</a></li>
                <li><a href="/blog">3</a></li>
                <li><a href="/blog">...</a></li>
                <li className="prv-right">
                  <a href="/blog"><i className="fas fa-angle-double-right" /></a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-4">
            <aside className="blog-sidebar">
              <div className="blog-widget">
                <h2 className="bw-title">Search Here</h2>
                <form action="#" className="sidebar-search">
                  <input type="text" placeholder="Search post" />
                  <button type="submit"><i className="fas fa-search" /></button>
                </form>
              </div>
              <div className="blog-widget">
                <h2 className="bw-title">Categories</h2>
                <div className="category-list">
                  <ul>
                    <li><a href="#">Chemistry <span>03</span></a></li>
                    <li><a href="#">Forensic science <span>07</span></a></li>
                    <li><a href="#">Gemological <span>09</span></a></li>
                    <li><a href="#">Chemistry <span>01</span></a></li>
                    <li><a href="#">UI/UX Deisgn <span>00</span></a></li>
                    <li><a href="#">Gemological <span>26</span></a></li>
                  </ul>
                </div>
              </div>
              <div className="blog-widget">
                <h2 className="bw-title">Pages</h2>
                <div className="page-list">
                  <ul>
                    <li><a href="#">Web Design<i className="fas fa-chevron-right" /></a></li>
                    <li><a href="#">Branding Design<i className="fas fa-chevron-right" /></a></li>
                    <li><a href="#">Photography<i className="fas fa-chevron-right" /></a></li>
                    <li><a href="#">Business Statergy<i className="fas fa-chevron-right" /></a></li>
                    <li><a href="#">UI/UX Deisgn<i className="fas fa-chevron-right" /></a></li>
                    <li><a href="#">Web Development<i className="fas fa-chevron-right" /></a></li>
                  </ul>
                </div>
              </div>
              <div className="blog-widget">
                <h2 className="bw-title">Recent Post</h2>
                <div className="rc-post-wrap">
                  <div className="rc-post-item">
                    <div className="rc-post-thumb">
                      <a href="/blog-details"><img src="assets/img/blog/rc_post_img01.jpg" alt /></a>
                    </div>
                    <div className="rc-post-content">
                      <span>4 March. 2023</span>
                      <h4 className="title"><a href="/blog-details">Don’t Underestimate The Software</a></h4>
                    </div>
                  </div>
                  <div className="rc-post-item">
                    <div className="rc-post-thumb">
                      <a href="/blog-details"><img src="assets/img/blog/rc_post_img02.jpg" alt /></a>
                    </div>
                    <div className="rc-post-content">
                      <span>4 March. 2023</span>
                      <h4 className="title"><a href="/blog-details">Designing Human-Machine Interfaces..</a></h4>
                    </div>
                  </div>
                  <div className="rc-post-item">
                    <div className="rc-post-thumb">
                      <a href="/blog-details"><img src="assets/img/blog/rc_post_img03.jpg" alt /></a>
                    </div>
                    <div className="rc-post-content">
                      <span>4 March. 2023</span>
                      <h4 className="title"><a href="/blog-details">Web Design Done Well: Excellent</a></h4>
                    </div>
                  </div>
                  <div className="rc-post-item">
                    <div className="rc-post-thumb">
                      <a href="/blog-details"><img src="assets/img/blog/rc_post_img04.jpg" alt /></a>
                    </div>
                    <div className="rc-post-content">
                      <span>4 March. 2023</span>
                      <h4 className="title"><a href="/blog-details">Don’t Underestimate The Software</a></h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className="blog-widget">
                <h2 className="bw-title">Popular Tag</h2>
                <div className="tag-list">
                  <ul>
                    <li><a href="#">landing</a></li>
                    <li><a href="#">Charity</a></li>
                    <li><a href="#">apps</a></li>
                    <li><a href="#">Education</a></li>
                    <li><a href="#">data</a></li>
                    <li><a href="#">book</a></li>
                    <li><a href="#">Design</a></li>
                    <li><a href="#">website</a></li>
                    <li><a href="#">landing page</a></li>
                    <li><a href="#">data</a></li>
                  </ul>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </section>
    {/* blog-area-end */}
  </main>
  {/* main-area-end */}
  {/* footer-area */}
  <footer>
    <div className="footer-area-three footer-bg">
      <div className="container">
        <div className="footer-top">
          <div className="row">
            <div className="col-xl-3 col-lg-4 col-md-6">
              <div className="footer-widget">
                <a href="/" className="f-logo"><img src="assets/img/logo/logo.png" alt /></a>
                <div className="footer-content">
                  <p>A new way to make the payments easy, reliable and 100% secure. claritatem itamconse
                    quat. Exerci tationulla</p>
                  <ul className="footer-social">
                    <li><a href="#"><i className="fab fa-youtube" /></a></li>
                    <li><a href="#"><i className="fab fa-twitter" /></a></li>
                    <li><a href="#"><i className="fab fa-facebook-f" /></a></li>
                    <li><a href="#"><i className="fab fa-skype" /></a></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-5 col-sm-6">
              <div className="footer-widget">
                <h4 className="fw-title">Usefull Links</h4>
                <div className="footer-link">
                  <ul>
                    <li><a href="#">Contact us</a></li>
                    <li><a href="#">How it Works</a></li>
                    <li><a href="#">Create</a></li>
                    <li><a href="#">Explore</a></li>
                    <li><a href="#">Terms &amp; Services</a></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xl-2 col-lg-3 col-sm-6">
              <div className="footer-widget">
                <h4 className="fw-title">Community</h4>
                <div className="footer-link">
                  <ul>
                    <li><a href="#">Help Center</a></li>
                    <li><a href="#">Partners</a></li>
                    <li><a href="#">Suggestions</a></li>
                    <li><a href="#">Blog</a></li>
                    <li><a href="#">Newsletters</a></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6">
              <div className="footer-widget">
                <h4 className="fw-title">Subscribe Newsletter</h4>
                <div className="footer-newsletter">
                  <p>Exerci tation ullamcorper suscipit lobortis nisl aliquip ex ea commodo</p>
                  <form action="#">
                    <input type="email" placeholder="Info@gmail.com" />
                    <button type="submit"><i className="fas fa-paper-plane" /></button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="copyright-text">
                <p>© Copyright 2023 Bigtech. All Rights Reserved Copyright</p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="footer-menu">
                <ul>
                  <li><a href="#">Terms and conditions</a></li>
                  <li><a href="#">Privacy policy</a></li>
                  <li><a href="#">Login / Signup</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
  {/* footer-area-end */}
</div>
    </>
  )
}

export default Blog